module.exports = __webpack_public_path__ + "img/caterpillar-logo.1c7cfed9.jpg";